import { theme } from '@arnold/common';
import { REPORT_LINK } from '@arnold/core';
import styled from '@emotion/styled/macro';
import { FC } from 'react';
import { Button } from 'react-bootstrap';
import { ReportPendingApprovalTooltip } from '../../components/ReportPendingApprovalTooltip';
import { ButtonLink } from '../../components/StyledComponents';
import DeleteSurvey from '../../components/SurveysOverview/DeleteSurvey';
import { Features, OrganizationSurveysQuery } from '../../generated/hooks';
import { goToTalkResults, isImportedPulserSurvey } from '../../lib/helpers';
import { useFeatureFlag } from '../../lib/helpers/hooks';
import { GetDataSourceParams } from './types';
import { isPrepared } from './utils';

type SurveyActionsProps = Pick<GetDataSourceParams, 'toSurveyDetail' | 'pathStatus' | 't'> & {
  survey: NonNullable<OrganizationSurveysQuery['organizationSurveys']>[0];
  label?: string;
};
export const SurveyActions: FC<SurveyActionsProps> = ({ survey, toSurveyDetail, pathStatus, t, label }) => {
  const { id, sendAt, endsAt, topLevelReport, isReportPendingApproval } = survey;
  const hasPulserModule = useFeatureFlag(Features.PulserModule);
  const hideDetail = hasPulserModule && isImportedPulserSurvey(survey);

  return (
    <Actions>
      {!hideDetail && (
        <ButtonLink
          weight={500}
          onClick={() => toSurveyDetail(id)}
          data-cy="admin-edit-survey"
          data-icom={'survey-detail-link'}
        >
          {t('surveyDetail')}
        </ButtonLink>
      )}
      {isPrepared(pathStatus) ? (
        <DeleteSurvey surveyId={id} label={label} sendAt={sendAt} endsAt={endsAt} data-icom={'survey-delete-link'} />
      ) : (
        <ReportPendingApprovalTooltip isPending={isReportPendingApproval}>
          <ResultsButton
            onClick={() => {
              if (topLevelReport?.accessKey && !isReportPendingApproval) {
                goToTalkResults(REPORT_LINK.REPORT, topLevelReport.accessKey);
              }
            }}
            disabled={!topLevelReport || isReportPendingApproval}
            data-icom={'survey-report-link'}
          >
            {t('summaryReport')}
          </ResultsButton>
        </ReportPendingApprovalTooltip>
      )}
    </Actions>
  );
};

const ResultsButton = styled(Button)`
  background-color: inherit;
  text-transform: none;
  color: ${theme.colors.actionPrimary.default};
  &:disabled {
    color: ${theme.colors.actionPrimary.disabled};
  }
`;

const Actions = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: end;
  gap: ${theme.spacing.f};
`;
